import { render, staticRenderFns } from "./salary_rule_config.vue?vue&type=template&id=392b65e8&scoped=true"
import script from "./salary_rule_config.vue?vue&type=script&lang=js"
export * from "./salary_rule_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392b65e8",
  null
  
)

export default component.exports